import { render, staticRenderFns } from "./addNews.vue?vue&type=template&id=24f55e82&lang=pug"
import script from "./addNews.vue?vue&type=script&lang=js"
export * from "./addNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports